module.exports = __webpack_public_path__ + "img/feature-interactive-kiosks.68e03fb2.png";